<template>
    <div>
        <div class="row">
            <div class="col-12 mb-3">
                <button class="close" @click="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h5>
                    Send Invoice
                </h5>
            </div>
        </div>
        <div class="row">
            <AppInput
                    v-model="email.recipients"
                    :errors="errors"
                    class="col-md-12"
                    label="Recipients"
                    field="recipients"
            />
        </div>
        <div class="row">
            <AppInput
                    v-model="email.subject"
                    :errors="errors"
                    class="col-md-12"
                    label="Subject"
                    field="subject"
            />
        </div>
        <div class="row">
            <AppTextArea
                    v-model="email.message"
                    label="Message"
                    field="message"
                    :errors="errors"
                    class="col-12"
            />
        </div>
        <div class="text-right">
            <button @click="sendInvoice" :disabled="loading" class="btn btn-primary">
                {{ loading ? 'Sending...' : 'Send'}}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AppInput from '../form/AppInput';
import AppTextArea from '../form/AppTextarea';
import Errors from '../../utils/errors';
import NotificationService from '../../services/notification.service';
import config from '../../config/app.config';

export default {
  components: {
    AppInput,
    AppTextArea,
  },
  data() {
    return {
      errors: new Errors(),
      email: {
        subject: '',
        message: '',
        recipients: '',
      },
      loading: false,
    };
  },
  mounted() {
    this.initEmail();
  },
  computed: {
    ...mapGetters({
      invoice: 'invoices/invoice',
    }),
  },
  methods: {
    initEmail() {
      this.seedRecipients();
      this.setContent();
    },
    setContent() {
      this.email.subject = `Invoice ${this.invoice.number}`;
      this.email.message = 'Please see invoice attached.';
    },
    close() {
      this.$store.commit('invoices/isSendInvoiceModalOpen', false);
    },
    sendInvoice() {
      this.loading = true;
      this.$store
        .dispatch('invoices/sendInvoice', this.email)
        .then((res) => {
          NotificationService.success(res.message);
          this.close();
          this.$router.push({
            name: 'invoices',
          });
        })
        .catch((err) => this.errors.set(err.response.data.errors))
        .finally(() => {
          this.loading = false;
        });
    },
    seedRecipients() {
      this.email.recipients += `${config.mail_admin},`;
      if (this.invoice.client_contact_user && this.invoice.client_contact_user.email) {
        this.email.recipients += `${this.invoice.client_contact_user.email},`;
      }
    },
  },
};
</script>
